import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { IFillDataWizardBuy, TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../../..";
import EstimateStep from "../../../../../../../shared/wizard/steps/estimateStep";
import { IDataFormEstimate } from "../../../../../../estimate";

interface ISureSwapStepBuy_1 {
  isNextStepDisabled: boolean;
  onChange: (data: Partial<IFillDataWizardBuy>) => void;
  onChangePrice: (data: number | number[], key: TNumberKeysOfIFillDataWizardBuy) => void;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
  dataFormEstimate: Partial<IFillDataWizardBuy>;
}

const SureSwapStepBuy_1 = ({
  isNextStepDisabled,
  onChange,
  onChangePrice,
  onReset,
  dataFormEstimate,
}: ISureSwapStepBuy_1) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.sureSteps.step_3);
    onReset(["streetId", "buildingId", "areaInSqM", "apartmentNumber"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.sureSteps.swap.step_2);
  };

  const dataFormEstimateChecked = Boolean(
    dataFormEstimate.areaInSqM &&
      dataFormEstimate.buildingId &&
      dataFormEstimate.streetId
  );

  const handleEstimatePrice = (value: number) => {
    onChangePrice(value, "estimatedPrice");
  };

  return (
    <div>
      <EstimateStep
        mode="quiz"
        onEstimatePrice={handleEstimatePrice}
        onEstimateForm={onChange}
        onNexStep={handleNexStep}
        onPrevStep={handlePrevStep}
        isNextStepDisabled={isNextStepDisabled}
        dataFormEstimate={
          dataFormEstimateChecked
            ? (dataFormEstimate as IDataFormEstimate)
            : undefined
        }
      />
    </div>
  );
};

export default SureSwapStepBuy_1;
